<nz-flex nzJustify="center" nzAlign="center" class="primary-bg h100">
  <nz-card [nzTitle]="'pages.pin-entry.title' | translate" [nzBordered]="false">
    <nz-flex [nzVertical]="true" nzJustify="space-between">
      <div class="text-center">
        <span
          nz-icon
          nzType="lock"
          nzTheme="outline"
          style="font-size: 48px"
          class="primary"
        ></span>
        <p class="text-gray-600">{{ 'pages.pin-entry.subtitle' | translate }}</p>
      </div>

      <form nz-form [formGroup]="form" (ngSubmit)="enterPin()" id="pin-entry-form">
        <nz-form-item>
          <nz-form-control [nzErrorTip]="'pages.pin-entry.error' | translate">
            <nz-input-group nzPrefixIcon="lock">
              <input
                type="password"
                nz-input
                formControlName="pin"
                [placeholder]="'pages.pin-entry.placeholder' | translate"
                maxlength="4"
                class="text-center pin-input"
                [disabled]="isLoading"
                id="pin-entry-pin-input"
              />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <div class="flex-column flex-align-center gap2 w100">
            <button
              nz-button
              nzType="primary"
              nzSize="large"
              [nzLoading]="isLoading"
              [disabled]="form.invalid"
              class="w100"
              id="pin-entry-submit-button"
            >
              {{ 'pages.pin-entry.enter' | translate }}
            </button>

            <button
              nz-button
              nzType="text"
              nzDanger
              nzSize="large"
              (click)="logout()"
              [disabled]="isLoading"
              class="w100"
              id="pin-entry-logout-button"
            >
              {{ 'pages.pin-entry.logout' | translate }}
            </button>
          </div>
        </nz-form-item>
      </form>
    </nz-flex>
  </nz-card>
</nz-flex>
